<button type="button" class="fn-switch"
  [disabled]="isDisabled"
  [class.fn-switch-checked]="checked"
  [class.ant-switch-disabled]="isDisabled"
  [class.fn-switch-small]="fnSize === 'small'"
  [class.fn-switch-large]="fnSize === 'large'"
  [style.background-color]="checked ? colorList[0] : colorList[1]"
  (click)="clickEvent($event)"
  (keydown)="onKeyDown($event)"
  [class]= "fnSwitchClass"
  >

  <span class="fn-switch-inner">
    <span>
      @if (checked) {
        <ng-container *ngTemplateOutlet="checkedTemplate || defaultTemplate"> </ng-container>
      }
      @if (!checked) {
        <ng-container *ngTemplateOutlet="unCheckedTemplate || defaultTemplate"> </ng-container>
      }
      <ng-template #defaultTemplate>
        <!-- {{checked ? 'Yes' : 'No'}} -->
      </ng-template>
    </span>
  </span>
</button>
